

<div class="hover-container-content-stakeholder-section" *ngFor=" let stakeholder of stakeholders">
  <div class="stakeholder-icon">
    <img class="icon" [src]="stakeholder.icon">
  </div>
  <div class="stakeholder-name">
    {{ stakeholder.firstName }} {{ stakeholder.surname }}
  </div>
  <div *ngIf="stakeholder.gender || stakeholder.age" class="stakeholder-gender-age">
    ({{ stakeholder.gender }} {{ stakeholder.age }})
  </div>
</div>
<hr>
<div class="hover-container-content-section-title">
  Supplier
</div>
<div class="hover-container-content-bold">
  {{providerName}}
</div>
<hr>
<div class="hover-container-content-section-title">
  Start
</div>
<div class="hover-container-content-bold">
  {{ serviceOrder.getStartDate() | momentFormat: 'DD MMM YYYY HH:mm' : serviceOrder.getStartLocation().timeZoneId}} ({{serviceOrder.getStartLocation().country}})
</div>
<div class="hover-container-content-italic">
  ({{ serviceOrder.getStartDate() | momentFormat: 'DD MMM YYYY HH:mm' : 'local'}} Denmark)
</div>
<div class="hover-container-content-italic">
  ({{serviceOrder.getStartDate() | momentFormat: 'DD MMM YYYY HH:mm' : 'local'}} Denmark)
</div>
<div class="hover-container-content-section-title">
  End
</div>
<div class="hover-container-content-bold">
  <span *ngIf="serviceOrder.getEndLocation()">{{ serviceOrder.getEndDate() | momentFormat: 'DD MMM YYYY HH:mm' : serviceOrder.getEndLocation()?.timeZoneId}} ({{serviceOrder.getEndLocation()?.country}})</span>
  <span *ngIf="!serviceOrder.getEndLocation()">{{ serviceOrder.getEndDate() | momentFormat: 'DD MMM YYYY HH:mm' : 'local'}} (Denmark)</span>
</div>
<div class="hover-container-content-italic">
  ({{serviceOrder.getEndDate() | momentFormat: 'DD MMM YYYY HH:mm' : 'local'}} Denmark)
</div>
<hr>
<div class="hover-container-content-section-title">
  Last edited
</div>
<div class="hover-container-content-bold">
      <span *ngIf="serviceOrder.lastEditedByInitials">
        {{serviceOrder.lastEditedByInitials | uppercase}}
      </span>
  <span *ngIf="serviceOrder.modifiedOn">
        {{serviceOrder.modifiedOn | momentFormat:'DD MMM YYYY HH:mm':'local'}}
      </span>
</div>
